import { useEffect, useState } from "react";
import { Button, Card, Col, Form, InputNumber, Row, Spin, message } from "antd";
import { DollarOutlined, SaveOutlined } from "@ant-design/icons";
import apiClient from "../../actions/api";
import openNotification from "../../components/Notifications/openNotification";
import "../../style/user/priceSettings.scss";

const PriceSettings = ({ title }) => {
  document.title = title;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient
      .get("/pricing")
      .then(({ data }) => form.setFieldsValue(data))
      .catch(() =>
        openNotification(
          "error",
          "Pricing unavailable",
          "Could not load the current prices.",
        ),
      )
      .finally(() => setLoading(false));
  }, [form]);

  const save = async (values) => {
    setSaving(true);
    try {
      await apiClient.put("/pricing", values);
      message.success("Prices updated successfully");
    } catch (error) {
      const detail =
        error?.response?.data?.errors?.[0]?.msg || "Could not update prices.";
      openNotification("error", "Update failed", detail);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="price-settings-page">
      <div className="price-settings-heading">
        <span>
          <DollarOutlined />
        </span>
        <div>
          <h1>Price settings</h1>
          <p>
            Set the usage charge deducted from a user's balance after each
            successful generation.
          </p>
        </div>
      </div>
      <Card className="price-settings-card" variant="borderless">
        {loading ? (
          <div className="price-settings-loading">
            <Spin size="large" />
          </div>
        ) : (
          <Form form={form} layout="vertical" onFinish={save}>
            <Row gutter={[20, 8]}>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Application answer"
                  name="answer"
                  extra="Charged per generated answer"
                  rules={[{ required: true }]}
                >
                  <InputNumber min={0} precision={6} step={0.001} prefix="$" />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Tailored resume"
                  name="resume"
                  extra="Includes DOCX and PDF"
                  rules={[{ required: true }]}
                >
                  <InputNumber min={0} precision={6} step={0.01} prefix="$" />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Tailored cover letter"
                  name="coverLetter"
                  extra="Charged per generated PDF"
                  rules={[{ required: true }]}
                >
                  <InputNumber min={0} precision={6} step={0.001} prefix="$" />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Job Board URL"
                  name="jobUrl"
                  extra="Charged once per job per user"
                  rules={[{ required: true }]}
                >
                  <InputNumber min={0} precision={6} step={0.001} prefix="$" />
                </Form.Item>
              </Col>
            </Row>
            <div className="price-settings-actions">
              <Button
                type="primary"
                htmlType="submit"
                loading={saving}
                icon={<SaveOutlined />}
              >
                Save prices
              </Button>
            </div>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default PriceSettings;
